<template>
	<div :class="{checkBox:true,disabled}" @click.stop="toggle">
		<div class="flex-align">
			<div :class="{state:true,'flex-center':true,active:dataView,round}" :style="{width:sizeView,height:sizeView}"></div>
			<div class="label flex-align" v-if="label.length || Object.keys($slots).length">
				<slot ></slot>
				<template v-if="!Object.keys($slots).length">
					{{label}}
				</template>
			</div>
		</div>
	</div>
</template>

<script setup>
	import {ref,getCurrentInstance,watch,computed} from "vue";
	let {proxy} = getCurrentInstance();
	let props = defineProps({
		modelValue:{
			type:Boolean,
			default:false,
		},
		label:{
			type:String,
			default:'',
		},
		disabled:{
			type:Boolean,
			default:false,
		},
		size:{
			type:[String,Number],
			default:13,
		},
		round:{
			type:Boolean,
			default:false,
		},
	})
	let dataView = ref(false);
	const emit = defineEmits(['update:modelValue','change']);
	watch(()=>props.modelValue,(v)=>{
		dataView.value = v;
	},{immediate:true});
	watch(()=>dataView.value,(v)=>{
		emit('update:modelValue',v);
		emit('change',v);
	})
	let toggle = ()=>{
		if(props.disabled)return;
		dataView.value = !dataView.value;
	}
	let sizeView = computed(()=>{
		let size = props.size;
		if(/px/.test(size)){
			return size;
		}else{
			return size + 'px';
		}
	})
</script>

<style lang="scss" scoped>
	.checkBox{
		width: unset;
		cursor:pointer;
		display: inline-block;
		.state{
			width: 13px;
			min-width: 13px;
			height: 13px;
			border-radius: 3px;
			background: #FFFFFF;
			border: 1px solid #A2A6BA;
			transition:all 0.3s;
			position: relative;
			&:hover{
				border-color: var(--qx2-primary-color);
			}
			&.active{
				background: var(--qx2-primary-linearGradient-color);
				border: unset;
				&:before,&:after{
					transition:all 0.3s;
					content:'';
					height:2px;
					background: #fff;
					border-radius:1px;
					position: absolute;
					top:50%;
					left:50%;
					transform-origin: 50% 50%;
				}
				&:before{
					width: 60%;
					transform: rotate(-53deg) translate(-10%,-160%);
				}
				&:after{
					width: 35%;
					transform: rotate(35deg) translate(-70%,222%);
				}
			}
			&.round{
				border-radius:50%;
			}
		}
		.label{
			font-family: PingFang-SC-Bold;
			font-size: inherit;
			color: #2B2C3C;
			margin-left: 9px;
		}
	}
</style>